import { FormGroup } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import styles from 'Components/FormField/FormField.module.css';
import { FormLabel } from 'Components/FormField/FormLabel/FormLabel';
import { FormFieldTooltip } from 'Components/Tooltips/FormFieldTooltip';

interface FormFieldDatePickerProps {
    formFieldId?: string;
    formFieldLabel: string;
    tooltip?: string;
    dateFormat?: string;
    placeholder?: string;
    selected?: any;
    /** A function that takes a single argument of type Date | undefined | null. When the user manually clears the date, the value is null. */
    handleChange?: any;
    disabled?: boolean;
    required?: boolean;
    datesRestriction?: 'pastDatesOnly' | 'futureDatesOnly';
}

export const FormFieldDatePicker = (props: FormFieldDatePickerProps) => {
    const [minDate, maxDate] = (() => {
        switch (props.datesRestriction) {
            case 'pastDatesOnly':
                return [undefined, new Date()];
            case 'futureDatesOnly':
                return [new Date(), undefined];
            default:
                return [undefined, undefined];
        }
    })();

    return (
        <FormGroup controlId={props.formFieldId} className={styles.formField}>
            <FormLabel required={props.required}>{props.formFieldLabel}</FormLabel>
            {props.tooltip && <FormFieldTooltip text={props.tooltip} />}
            <div className={styles.datePickerOverride}>
                {/* Using a `portalId` for `DatePicker` ensures the "popper" (the dialog where the user selects a date) renders above other elements even when the date picker is in a modal. Without `portalId`, date pickers will be clipped by the boundaries of modals, which are set to have scrollable overflowing content. */}
                <DatePicker portalId="react-datepicker-portal" autoComplete="off" name={props.formFieldId} id={props.formFieldId} className={`${styles.customFormControl}`} dateFormat={props.dateFormat} selected={props.selected} placeholderText={props.placeholder} onChange={props.handleChange} disabled={props.disabled} minDate={minDate} maxDate={maxDate} />
            </div>
        </FormGroup>
    );
};
